const HTML_ANCHOR_PATTERN = /<a\s+href=(["'])(.*?)\1[^>]*>([^<]*)<\/a>/i;
const ALLOWED_HREF_PATTERN = /^https?:\/\//i;

export interface SalesforceHtmlLink {
  href: string;
  label?: string;
}

export function parseSalesforceHtmlLink(html: string | null | undefined): SalesforceHtmlLink | undefined {
  const match = html?.match(HTML_ANCHOR_PATTERN);
  const href = match?.[2];
  const label = match?.[3]?.trim();

  if (!href || !ALLOWED_HREF_PATTERN.test(href)) {
    return undefined;
  }

  return label ? { href, label } : { href };
}
